import { ApplicationState } from 'AppReducer'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { formatDateTime, maskMoney } from 'util/masks'
import { Payment } from '../redux/types'

const BalanceItem: React.FC<{ payment: Payment }> = ({ payment }) => {
  const [isOpen, setOpen] = useState(false)
  const fontWeight = isOpen ? 'bold' : 'normal'
  const color = payment.amount > 0 ? 'green' : 'firebrick'

  const { types } = useSelector((state: ApplicationState) => state.balanceReducer)

  const gridTemplateColumns = '200px 1fr 150px 200px 220px 220px 48px'

  const total = payment.children.reduce((acc, item) => (acc += item.amount), 0)

  return (
    <>
      <div className="list-row" style={{ display: 'grid', gridTemplateColumns, fontWeight, color }}>
        <div>{ types[payment.type] }</div>
        <div>{ payment.description }</div>
        <div>{ maskMoney(payment.amount) }</div>
        <div>{ formatDateTime(payment.createdAt) }</div>
        <div>{ payment.from }</div>
        <div>{ payment.to }</div>
        {
          payment.children?.length > 0 &&
          <div onClick={(): void => setOpen(!isOpen)}>
            <span className="button primary"><i className="fa fa-folder-open"/></span>
          </div>
        }
      </div>
      {
        isOpen &&
        <div className="row" style={{ borderTop: '1px solid gainsboro', gridColumn: '1 / 8', marginTop: -8 }}>
          {
            payment.children?.map((item, i) => {
              const gridTemplateColumns = '200px 1fr 150px 200px 220px 220px 48px'
              return (
                <div
                  key={i}
                  className="list-row"
                  style={{ display: 'grid', gridTemplateColumns, fontWeight: 'normal', margin: 0 }}
                >
                  <div>{ types[item.type] }</div>
                  <div>{ item.description }</div>
                  <div>{ maskMoney(item.amount) }</div>
                  <div>{ formatDateTime(item.createdAt) }</div>
                  <div>{ item.from }</div>
                  <div>{ item.to }</div>
                </div>
              )
            })
          }
          <h3 className="row panel justify-end">
            Valor Líquido: { maskMoney(total) }
          </h3>
        </div>
      }
    </>
  )
}

export default BalanceItem
